export default {"src":"/_next/static/media/dent.558ec999.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};